/* eslint-disable react/jsx-key */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
    Checkbox,
    CompactPeoplePicker, //CompactPeoplePicker,
    Dropdown,
    DropdownMenuItemType,
    FontSizes,
    Icon,
    IDropdownOption,
    IDropdownStyles,
    TextField,
    ValidationState,
} from "@fluentui/react";
import { Client } from "@microsoft/microsoft-graph-client";
import React from "react";
import { ITeams, ITeamTag } from "./IEntities";
import { IPersonaProps, IPersonaSharedProps, Persona, PersonaSize } from "@fluentui/react/lib/Persona";

interface ITeamTagProps {
    client: Client;
    team: ITeams;
    channelID: string;
    userOrTag: number;
    userEmai: string;
    // eslint-disable-next-line no-undef
    //  oContext: Office.Context;
}
interface ITeamsTagState {
    users?: IPersonaSharedProps;
    delayResults: boolean;
    isPickerDisabled: boolean;
    peopleList?: any;
    mostRecentlyUsed?: any;
    tags?: ITeamTag[];
    tagOptions?: { key: string; text: string; }[];
    refresh: boolean;
}
const examplePersona: IPersonaSharedProps = {
    imageUrl: '',
    imageInitials: 'AL',
    text: 'Annie Lindqvist',
    secondaryText: 'Software Engineer',
    tertiaryText: 'In a meeting',
    optionalText: 'Available at 4:00pm',
};
export class TeamTag extends React.Component<ITeamTagProps, ITeamsTagState> {
    protected picker: any;
    protected users: IPersonaSharedProps[] = [];
    protected TeamOptions: { TagId?: string, channelID: string, hasAttach: boolean, message: string, sendTo: string[], team: ITeams };


    constructor(props: ITeamTagProps) {
        super(props);
        this.state = {
            refresh: false,
            tagOptions: [],
            delayResults: false,
            isPickerDisabled: true,
        };
        this.picker = React.createRef();
        this.TeamOptions = { TagId: '', channelID: '', hasAttach: false, message: '', sendTo: [], team: this.props.team };
    }
    
    componentDidMount(): void {
        const tags: ITeamTag[] = [];
        const { client, team } = this.props;

        const fetchMembers = client
            .api(`https://graph.microsoft.com/v1.0/teams/${team.id}/members/`)
            .get()
            .then((response: any) => {
                response.value.forEach((user: any) => {
                    const initials = user.displayName.split(" ").length > 1
                        ? user.displayName.split(" ")[0].substring(0, 1).toUpperCase() + user.displayName.split(" ")[1].substring(0, 1).toUpperCase()
                        : user.displayName.substring(0, 2).toUpperCase();

                    this.users.push({
                        text: user.displayName,
                        imageInitials: initials,
                        coinSize: 20,
                        primaryText: user.displayName,
                        secondaryText: user.userId,
                        showSecondaryText: false,
                    });
                    if (this.props.userEmai.toLowerCase() === user.email.toLowerCase()) {
                        this.TeamOptions.sendTo.filter(x => x === user.userId).length <= 0 &&
                            this.TeamOptions.sendTo.push(user.userId);
                    }
                    
                });
            })
            .catch(error => {
                // eslint-disable-next-line no-undef
                console.log('Error ', `https://graph.microsoft.com/v1.0/teams/${team.id}/members/`, ' ', error);
            });

        const fetchTags = client
            .api(`https://graph.microsoft.com/v1.0/teams/${team.id}/tags`)
            .get()
            .then((response: any) => {
                response.value.forEach((tag: any) => {
                    tags.push({
                        id: tag.id,
                        teamId: tag.teamId,
                        displayName: tag.displayName,
                        description: tag.description,
                        memberCount: tag.memberCount,
                        tagType: tag.tagType,
                        users: []
                    });
                });
            })
            .catch(error => {
                // eslint-disable-next-line no-undef
                console.log('Error ', `https://graph.microsoft.com/v1.0/teams/${team.id}/tags`, ' ', error);
            });

        Promise.all([fetchMembers, fetchTags])
            .then(() => {
                const fetchTagMembersPromises = tags.map((tag) => {
                    return client
                        .api(`https://graph.microsoft.com/v1.0/teams/${team.id}/tags/${tag.id}/members`)
                        .get()
                        .then((response: any) => {
                            const users = response.value.map((user: any) => {
                                const initials = user.displayName.split(" ").length > 1
                                    ? user.displayName.split(" ")[0].substring(0, 1).toUpperCase() + user.displayName.split(" ")[1].substring(0, 1).toUpperCase()
                                    : user.displayName.substring(0, 2).toUpperCase();
                                return {
                                    text: user.displayName,
                                    imageInitials: initials,
                                    coinSize: 20,
                                    primaryText: user.displayName,
                                    secondaryText: user.userId,
                                    showSecondaryText: false,
                                };
                            });
                            tag.users = users;
                        })
                        .catch(error => {
                            // eslint-disable-next-line no-undef
                            console.log('Error ', `https://graph.microsoft.com/v1.0/teams/${team.id}/tags/${tag.id}/members`, ' ', error);
                        });
                });

                return Promise.all(fetchTagMembersPromises);
            })
            .then(() => {
                const options = tags.map((tag: ITeamTag) => ({ key: tag.id, text: tag.displayName }));

                this.setState({ isPickerDisabled: false, tags: tags, tagOptions: options });
            })
            .catch((error) => {
                // eslint-disable-next-line no-undef
                console.error('Error fetching data:', error);
            });
    }
    onFilterChanged = (filterText, currentPersonas, limitResults) => {
        if (filterText) {
            let filteredPersonas = this.filterPersonasByText(filterText);

            filteredPersonas = this.removeDuplicates(filteredPersonas, currentPersonas);
            filteredPersonas = limitResults ? filteredPersonas.slice(0, limitResults) : filteredPersonas;
            return this.filterPromise(filteredPersonas);
        } else {
            return [];
        }
    };
    filterPersonasByText = (filterText) => {
        return this.users.filter((item) => this.doesTextStartWith(item.text, filterText));
    };
    filterPromise = (personasToReturn) => {
        if (this.state.delayResults) {
            return this.convertResultsToPromise(personasToReturn);
        } else {
            return personasToReturn;
        }
    };
    returnMostRecentlyUsed = (currentPersonas) => {
        return this.filterPromise(this.removeDuplicates(this.users, currentPersonas));
    };
    onRemoveSuggestion = (item) => {
        const indexPeopleList = this.users.indexOf(item);
        const indexMostRecentlyUsed = this.users.indexOf(item);

        if (indexPeopleList >= 0) {
            const newPeople = this.users.slice(0, indexPeopleList).concat(this.users.slice(indexPeopleList + 1));
            this.setState({ peopleList: newPeople });
        }

        if (indexMostRecentlyUsed >= 0) {
            const newSuggestedPeople = this.users
                .slice(0, indexMostRecentlyUsed)
                .concat(this.users.slice(indexMostRecentlyUsed + 1));
            this.setState({ mostRecentlyUsed: newSuggestedPeople });
        }
    };
    onDisabledButtonClick = () => {
        this.setState({ isPickerDisabled: !this.state.isPickerDisabled });
    };
    onToggleDelayResultsChange = () => {
        this.setState({ delayResults: !this.state.delayResults });
    };
    doesTextStartWith = (text, filterText) => {
        return text.toLowerCase().indexOf(filterText.toLowerCase()) === 0;
    };
    removeDuplicates = (personas, possibleDupes) => {
        return personas.filter((persona) => !this.listContainsPersona(persona, possibleDupes));
    };
    listContainsPersona = (persona, personas) => {
        if (!personas || !personas.length || personas.length === 0) {
            return false;
        }
        return personas.filter((item) => item.text === persona.text).length > 0;
    };
    convertResultsToPromise = (results) => {
        // eslint-disable-next-line no-undef
        return new Promise((resolve) => setTimeout(() => resolve(results), 2000));
    };
    getTextFromItem = (persona) => {
        return persona.text;
    };
    validateInput = (input) => {
        if (input.indexOf("@") !== -1) {
            return ValidationState.valid;
        } else if (input.length > 1) {
            return ValidationState.warning;
        } else {
            return ValidationState.invalid;
        }
    };
    public render(): React.ReactNode {

        return (
            <div>
                <div style={{ paddingTop: 10, paddingBottom: 10 }}>
                    <Checkbox label="Include Attachment" onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
                        // eslint-disable-next-line no-undef
                        console.log(ev);
                        this.TeamOptions.hasAttach = checked;
                        this.TeamOptions.channelID = this.props.channelID;
                        // eslint-disable-next-line no-undef
                        sessionStorage.setItem('TeamTag', JSON.stringify(this.TeamOptions));
                    }} />
                </div>
                <div style={{ paddingTop: 10, paddingBottom: 10 }}>
                    {this.props.userOrTag == 1 &&

                        <div>
                            <Dropdown
                                placeholder="Select options"
                                label="Teams tags"
                                onChange={(_event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, _index?: number) => {
                                    this.TeamOptions.TagId = option.key as string;
                                    this.TeamOptions.channelID = this.props.channelID;
                                    // this.TeamOptions.sendTo = this.state.tags.find(x => x.id == this.TeamOptions.TagId).users.map((item) => (item.secondaryText));
                                    // // eslint-disable-next-line no-undef
                                    // sessionStorage.setItem('TeamTag', JSON.stringify(this.TeamOptions));
                                    this.setState({ refresh: !this.state.refresh });
                                }}

                                options={this.state.tagOptions !== undefined && this.state.tagOptions}
                                styles={{ root: { width: '100%' } }}
                            />
                            <br />
                            <table>
                                {this.state.tags !== undefined && this.state.tags.filter(x => x.id == this.TeamOptions.TagId)[0] !== undefined &&
                                    <tr><td><Checkbox onChange={() => {

                                        this.state.tags.find(x => x.id == this.TeamOptions.TagId).users.map((item) => {

                                            this.TeamOptions.sendTo.filter(x => x == item.secondaryText).length <= 0 &&
                                                this.TeamOptions.sendTo.push(item.secondaryText);
                                        });

                                        // eslint-disable-next-line no-undef
                                        sessionStorage.setItem('TeamTag', JSON.stringify(this.TeamOptions));
                                    }} /></td><td><Icon iconName="People" styles={{ root: { fontSize: FontSizes.smallPlus } }} />All Members of this Tag</td></tr>
                                }
                                {this.state.tags !== undefined && this.state.tags.filter(x => x.id == this.TeamOptions.TagId)[0] !== undefined &&
                                    this.state.tags.find(x => x.id == this.TeamOptions.TagId).users.map((item) => (<tr><td><Checkbox onChange={() => {
                                        this.TeamOptions.sendTo.filter(x => x == item.secondaryText).length <= 0 &&
                                            this.TeamOptions.sendTo.push(item.secondaryText);
                                        // eslint-disable-next-line no-undef
                                        sessionStorage.setItem('TeamTag', JSON.stringify(this.TeamOptions));
                                    }} /></td><td><Icon iconName="People" styles={{ root: { fontSize: FontSizes.smallPlus } }} />{item.text}</td></tr>))
                                }
                            </table>
                        </div>
                    }
                </div>




                <br />

                {
                    this.props.userOrTag == 2 &&
                    <CompactPeoplePicker
                        // onRemoveSuggestion={this.onFilterChanged}
                        onEmptyInputFocus={this.returnMostRecentlyUsed}
                        getTextFromItem={this.getTextFromItem}
                        //  pickerSuggestionsProps={this.users}
                        selectionAriaLabel={"Selected contacts"}
                        removeButtonAriaLabel={"Remove"}
                        className={"ms-PeoplePicker"}
                        aria-label="ffff"
                        //  onRemoveSuggestion={this.onRemoveSuggestion}
                        onValidateInput={this.validateInput}
                        //   inputProps={{
                        //     onBlur: (ev) => console.log("onBlur called", ev),
                        //     onFocus: (ev) => console.log("onFocus called", ev),
                        //     "aria-label": "People Picker",
                        //   }}
                        onChange={(items?: IPersonaProps[]) => {
                            this.TeamOptions.channelID = this.props.channelID;
                            const users = items.map((user) => (user.secondaryText));
                           // this.TeamOptions.sendTo = users;
                            users.forEach((user) => {
                                this.TeamOptions.sendTo.filter(x => x == user).length <= 0 &&
                                    this.TeamOptions.sendTo.push(user);
                             });
 
                            // eslint-disable-next-line no-undef
                            sessionStorage.setItem('TeamTag', JSON.stringify(this.TeamOptions));


                        }}
                        componentRef={this.picker}
                        resolveDelay={300}
                        disabled={false}
                        onResolveSuggestions={function (
                            _filter: string,
                            _selectedItems?: IPersonaProps[]
                        ): IPersonaProps[] | PromiseLike<IPersonaProps[]> {
                            throw new Error("Function not implemented.");
                        }}
                    />
                }

                <div style={{ paddingTop: 10, paddingBottom: 10 }}>
                    <TextField
                        label="Message To Tagged Users"
                        multiline={true}
                        height={200}
                        styles={{ fieldGroup: { height: 300 }, field: { height: 300 } }}
                        // eslint-disable-next-line react/jsx-no-bind
                        onChange={(_event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
                            this.TeamOptions.message = newValue;
                            // eslint-disable-next-line no-undef
                            sessionStorage.setItem('TeamTag', JSON.stringify(this.TeamOptions));
                        }}
                    />
                </div>
            </div>
        );
    }
}



// componentDidMount(): void {
    //     const tags: ITeamTag[] = [];
    //   const promise1= this.props.client
    //         .api(`https://graph.microsoft.com/v1.0/teams/${this.props.team.id}/members/`)
    //         .get()
    //         .then((response: any) => {
    //             response.value.map((user: any) => {
    //                 const initials =
    //                     user.displayName.split(" ").length > 1
    //                         ? user.displayName.split(" ")[0].substring(0, 1).toUpperCase() +
    //                         user.displayName.split(" ")[1].substring(0, 1).toUpperCase()
    //                         : user.displayName.substring(0, 1).toUpperCase();

    //                 this.users.push({
    //                     text: user.displayName,
    //                     imageInitials: initials,
    //                     coinSize: 20,
    //                     //    theme: theme,
    //                     primaryText: user.displayName,
    //                     secondaryText: user.id,
    //                     showSecondaryText: false,
    //                 });
    //             });

    //         });
    //     const promise2 = this.props.client
    //         .api(`https://graph.microsoft.com/beta/teams/${this.props.team.id}/tags`)
    //         .get()
    //         .then((response: any) => {

    //             response.value.map((tag: any) => {
    //                 tags.push({
    //                     id: tag.id,
    //                     teamId: tag.teamId,
    //                     displayName: tag.displayName,
    //                     description: tag.description,
    //                     memberCount: tag.memberCount,
    //                     tagType: tag.tagType,
    //                     users: []
    //                 });
    //             });

    //         }); 
    //     Promise.all([promise1, promise2]).then(() => {

    //         const promise4 = tags.map((tag) => {

    //             this.props.client
    //                 .api(`https://graph.microsoft.com/v1.0/teams/${this.props.team.id}/tags/${tag.id}/members`)
    //                 .get()
    //                 .then((response: any) => {
    //                     response.value.map((user: any) => {
    //                         const _users: IPersonaSharedProps[] = [];
    //                         const initials =
    //                             user.displayName.split(" ").length > 1
    //                                 ? user.displayName.split(" ")[0].substring(0, 1).toUpperCase() +
    //                                 user.displayName.split(" ")[1].substring(0, 1).toUpperCase()
    //                                 : user.displayName.substring(0, 1).toUpperCase();

    //                         _users.push({
    //                             text: user.displayName,
    //                             imageInitials: initials,
    //                             coinSize: 20,
    //                             //    theme: theme,
    //                             primaryText: user.displayName,
    //                             secondaryText: user.id,
    //                             showSecondaryText: false,
    //                         });
    //                         tag.users = _users;

    //                     });

    //                 });
    //         });

    //         Promise.all(promise4).then(() => {
    //             this.setState({ isPickerDisabled: false });
    //         });  
    //     });
    // }